module.exports = __webpack_public_path__ + "static/media/Shells_Manjaro_Icon.66dba5d3.svg";